import React, {useEffect, useRef, useState} from "react";
import {useCompany} from "../../../../hooks";
import QuickInfoPanel from "../../../../assets/js/layout/extended/info-panel";
import moment from "moment";
import AnimateLoading from "../../../_partials/controls/AnimateLoading";
import {CircularProgress, Typography} from "@material-ui/core";
import {Col} from "react-bootstrap";
import Loading from "./Loading";
import {formatDate} from  "../../../_helpers/DateTimeHelpers";

export default function CompanyInfo({companyId}) {
    const {isLoading, error, data, isFetching} = useCompany(companyId);
    const [company, setCompany] = useState(null);
    const [offices, setOffices] = useState([]);
    const scrollInfo = useRef(null);

    useEffect(() => {
        if (data && typeof data.data.data !== 'undefined') {
            setCompany(data.data.data.company || null);
            setOffices(data.data.data.offices || []);
        }
    }, [data]);

    useEffect(() => {
        if (scrollInfo.current) {
            QuickInfoPanel.init(scrollInfo.current.id)
        }
    }, [company]);

    if (!company) return <Loading/>;

    return (
        <div className="offcanvas-content px-10 pt-6" id="company-info-panel" ref={scrollInfo}>
            <div className="text-center mb-2">
                <div className="symbol symbol-xl-80">
                    <div className="symbol-label"></div>
                </div>
                <h6 className="font-weight-bold my-2">{company.company_name}</h6>
                <div className="text-primary mb-2">
                    <img className="minimized-logo mr-2" alt="logo" src="/media/logos/OptimumDesk-logo.png"
                         height="15"/>
                    v{company.odVersion.version}
                </div>
            </div>

            <div className="separator separator-dashed mt-8 mb-5"></div>

            <div>
                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Email:</span>
                    <a href="#" className="text-muted text-hover-primary">{company.email}</a>
                </div>
                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Phone:</span>
                    <span className="text-muted">{company.phone}</span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Address:</span>
                    <span className="text-muted text-right">{company.address}</span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Created:</span>
                    <span className="text-muted text-right">{formatDate(company.created)}</span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Contact person:</span>
                    <span className="text-muted text-right">{company.contact_person}</span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Working schedule:</span>
                    <span className="text-muted text-right">{company.working_schedule}</span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Offices:</span>
                    <span className="badge badge-primary text-right">{offices.length}</span>
                </div>
            </div>

            <div className="separator separator-dashed mt-8 mb-5"></div>

            {company.account_manager && <div>
                <h5 className="mb-5">IT Manager</h5>

                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Name:</span>
                    <span className="text-muted text-right">
                        {company.account_manager.firstname} {company.account_manager.lastname}
                    </span>
                </div>

                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Email:</span>
                    <span className="text-muted text-right">{company.account_manager.email}</span>
                </div>

                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Phone:</span>
                    <span className="text-muted text-right">{company.account_manager.phone}</span>
                </div>

                <div className="d-flex justify-content-between mb-2">
                    <span className="font-weight-bold mr-4">Phone 2:</span>
                    <span className="text-muted text-right">{company.account_manager.work_phone}</span>
                </div>
            </div>
            }
        </div>
    );
}
